import { LoquixSuggestionChips } from './loquix-suggestion-chips.js';

if (!customElements.get('loquix-suggestion-chips')) {
  customElements.define('loquix-suggestion-chips', LoquixSuggestionChips);
}
